import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-navy-card relative overflow-hidden" data-id="element-245" data-mp="1d0cpnrg32dfu">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-246" data-mp="1rqbirfss6yog"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-247" data-mp="1mtbe99bky3zg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-248" data-mp="z25yeu5n3bp5">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-249" data-mp="17zq4cgeg5w63">
            <span className="text-2xl" data-id="element-250" data-mp="2jgy8d0l6la9q">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-251" data-mp="2jjaxpyt9qmwt">
            The most complete Spanish teaching system for middle and high school
            teachers worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-252" data-mp="2bxtdkvg755xs">
            Spanish Teacher Ready™
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-253" data-mp="2kwdqth2zmnem">
            120 Ready-to-Teach Spanish Lessons · 5 Strategic Bonuses ·
            Everything ready to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-254" data-mp="1t5r5i8hmexz5">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-navy-border" data-id="element-255" data-mp="1t34qxowbbi7f">
            <div className="flex items-start gap-3" data-id="element-256" data-mp="19g6x2z5g3rrn">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-257" data-mp="1egbgoy1nh2m3" />
              <p className="text-gray-400 text-sm" data-id="element-258" data-mp="1eeiatkyv2mf5">
                This is not a collection of random worksheets pulled from the
                internet.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-259" data-mp="2crmgas7a9wb5">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-260" data-mp="2qk2cpa5oiw33" />
              <p className="text-gray-400 text-sm" data-id="element-261" data-mp="2qlnad8naiv56">
                This is not a theory book you need to rewrite before it works in
                a real classroom.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-262" data-mp="1yu7mzcdwt4dw">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-263" data-mp="1tubilc1avaxt" />
              <p className="text-gray-400 text-sm" data-id="element-264" data-mp="27st4r5bk4fdm">
                This is not content designed for a different context that you
                have to completely adapt.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-265" data-mp="3j76obxza28nu">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-266" data-mp="3cs7uj1k5m9ta"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-267" data-mp="3hqj193f5k47a">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-268" data-mp="3hsvtc9emjuy2" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-269" data-mp="9br91uqulbpw">
                This is a complete professional teaching system — so you walk
                into every single class fully prepared, confident and ready to
                deliver a lesson your students will actually learn from.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}